export default __webpack_public_path__ + "locales/children.ru.json";